export default __webpack_public_path__ + "static/media/442.a6e9a13c.svg";